import {
  ONE_SECOND_MS,
  TIME_UNTIL_DISCONNECTION_MS,
} from '@fintronners/react-utils/src/envConstants';
/**
 * Constants for the application
 *
 *
 * @file defines the constants for the NextJS application
 *
 */
export const IS_DEV_MODE = process.env.NODE_ENV !== 'production';

const ACCOUNTS = '/accounts';

export const PATHS = {
  LOGIN: '/login',
  LOGOUT: '/logout',
  REDIRECT: '/redirect',
  REAUTH: '/reauth',
  SESSION_EXPIRED: '/session-expired',
  AFTER_LOGIN_SUCCESS: ACCOUNTS,
  HOME: ACCOUNTS,
} as const;

/** Time the user has to answer the inactivity alert */
export const TIME_UNTIL_REDIRECTION_MS = ONE_SECOND_MS * 30;
/** Time to show the inactivity alert if no activity is detected */
export const TIME_UNTIL_INACTIVITY_ALERT_MS =
  TIME_UNTIL_DISCONNECTION_MS - TIME_UNTIL_REDIRECTION_MS;
export const ACTIVITY_EVENTS: string[] = ['mousemove', 'keydown', 'scroll', 'pointerdown'];
